import { Typography, Container, Paper } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useKeycloak } from '@react-keycloak/web';
import { Colors } from 'constants/colors';
import './styles.css';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
});

export const Unauthorized = () => {
  const { keycloak } = useKeycloak();
  return (
    <ThemeProvider theme={theme}>
      <Container
        maxWidth="sm"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <Paper
          elevation={1}
          sx={{
            p: 5,
            textAlign: 'center',
            backgroundColor: Colors.white,
            boxShadow: 'none',
          }}
        >
          <Typography
            color="textSecondary"
            sx={{
              fontWeight: 500,
              fontSize: '50px',
            }}
          >
            403
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
            }}
            color="textSecondary"
            mt={2}
          >
            You are not authorized for selected action
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
            }}
            color="textSecondary"
            mt={2}
          >
            Go to{' '}
            <span
              className="logout-link"
              onClick={() => {
                keycloak.logout({
                  redirectUri: window.location.origin,
                });
              }}
            >
              login page
            </span>
          </Typography>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};
